import { createApp } from 'vue'
import './bootstrap.css'
import App from './App.vue'
import router from './router'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import BugsnagPerformance from '@bugsnag/browser-performance'
import { createPinia } from 'pinia'
import 'skeleton-screen-css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'croppie/croppie.css'
import VueSocketIO from 'vue-3-socket.io'
import env from './env'
import { clearErrors } from './services/error'
import { useToast } from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
import { bugsnagKey } from './env'

window.addEventListener('error', event => {
  notifyError(event.message)
})

const userObject = JSON.parse(localStorage.getItem('user'))

const isUserLoggedIn =
  userObject && userObject.ID && userObject.display_name && userObject.user_email

if (isUserLoggedIn) {
  Bugsnag.start({
    apiKey: bugsnagKey,
    plugins: [new BugsnagPluginVue()],
    user: {
      id: userObject.ID,
      name: userObject.display_name,
      email: userObject.user_email,
    },
  })
  BugsnagPerformance.start({ apiKey: bugsnagKey })
}

const bugsnagVue = Bugsnag.getPlugin('vue')

const AN_HOUR = 60 * 60 * 1000

setInterval(() => {
  clearErrors()
}, AN_HOUR * 2)

/**
 * This will present the user with a prompt to install the app if is not
 * already installed.
 */
let deferredPrompt

window.addEventListener('beforeinstallprompt', function (e) {
  e.preventDefault()
  deferredPrompt = e
  return false
})

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(new VueSocketIO({ connection: env.wsUrl }))
app.use(bugsnagVue)
app.mount('#app')

const $toast = useToast()

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    const registration = await navigator.serviceWorker.register('/sw.js')

    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing
      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          $toast.open({
            message: ` <div class="d-flex flex-column align-items-center p-3">
              <div class="mb-2">ℹ️ Hay una nueva versión disponible</div>
              <button class="btn btn-primary text-white" onclick="window.open(location.href, '_self')">Actualizar</button>
            </div>`,
            duration: 60000,
            position: 'top',
            type: 'default',
            dismissible: false,
          })
        }
      })
    })
  })
}

import * as bootstrap from 'bootstrap'
import { notifyError } from './services/logger'
window.bootstrap = bootstrap
